import { ref, computed } from 'vue';
import { LISTEN } from "@/services/host";

// Estado global de la estación actual
const currentStationId = ref('3'); // Por defecto Riot (única estación)

// Detectar si estamos en desarrollo o producción
const isDev = process.env.NODE_ENV === 'development';

// Configuración de estaciones
const stations = {
  '3': {
    id: '3',
    name: 'Riot',
    slug: 'riot',
    url: '/canales/riot',
    streamUrl: `${LISTEN}/listen/riot/radio.mp3`,
    hlsUrl: isDev ? '/hls/riot/live.m3u8' : `${LISTEN}/hls/riot/live.m3u8`, // 🎬 HLS stream con buffer de 60s
    description: 'Música underground, punk y hardcore'
  }
};

export default function useCurrentStation() {
  // Computed para obtener la estación actual
  const currentStation = computed(() => stations[currentStationId.value]);
  
  // Función para cambiar de estación
  const setStation = (stationId) => {
    console.log(`🔧 setStation llamada: ${currentStationId.value} → ${stationId}`);
    if (stations[stationId]) {
      if (currentStationId.value === stationId) {
        console.log(`⚠️ Ya estás en la estación ${stationId}, forzando reproducción...`);
        // En lugar de cambiar el estado, forzamos la reproducción directamente
        forcePlayStation(stationId);
      } else {
        currentStationId.value = stationId;
      }
    }
  };
  
  // Función para forzar la reproducción de una estación específica
  const forcePlayStation = (stationId) => {
    // Emitir un evento personalizado para forzar reproducción
    window.dispatchEvent(new CustomEvent('forcePlayStation', { 
      detail: { stationId, station: stations[stationId] } 
    }));
  };
  
  // Función para alternar entre estaciones
  const toggleStation = () => {
    currentStationId.value = currentStationId.value === '1' ? '3' : '1';
  };
  
  // Getters para datos específicos
  const getStationName = () => currentStation.value.name;
  const getStationId = () => currentStationId.value;
  const getAllStations = () => Object.values(stations);
  
  return {
    currentStationId,
    currentStation,
    setStation,
    toggleStation,
    forcePlayStation,
    getStationName,
    getStationId,
    getAllStations
  };
}